import { createRouter, createWebHistory } from 'vue-router';
import AboutPage from './pages/AboutPage.vue';
import ContactPage from './pages/ContactPage.vue';
import FaqPage from './pages/FaqPage.vue';
import HomePage from './pages/HomePage.vue';
import VisionPage from './pages/VisionPage.vue';
const routes = [
    { path: '/', name: 'home', component: HomePage, meta: { title: 'Home' } },
    { path: '/about', name: 'about', component: AboutPage, meta: { title: 'About Us' } },
    { path: '/faq', name: 'faq', component: FaqPage, meta: { title: 'Frequently Asked Questions' } },
    { path: '/contact', name: 'contact', component: ContactPage, meta: { title: 'Contact Us' } },
    { path: '/vision', name: 'vision', component: VisionPage, meta: { title: 'Company Vision' } },
];
export const router = createRouter({
    history: createWebHistory(),
    routes,
    scrollBehavior(to) {
        if (to.hash) {
            return { el: to.hash, behavior: 'smooth' };
        }
        return { top: 0, behavior: 'smooth' };
    },
});
router.afterEach(to => {
    document.title = `${to.meta.title ?? 'ALQASWA ALKOBRA'} | ALQASWA ALKOBRA`;
});
